import { render } from "./index.vue?vue&type=template&id=1a4b8d80"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PageHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a4b8d80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a4b8d80', __exports__)) {
    api.reload('1a4b8d80', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1a4b8d80", () => {
    api.rerender('1a4b8d80', render)
  })

}


export default __exports__